module.exports = __webpack_public_path__ + "img/logo.b9118b18.png";